import { Component, OnInit, AfterContentInit, ViewChild, EventEmitter, ElementRef, OnDestroy } from '@angular/core';
import { NgbActiveModal, NgbModalRef, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SubScriptionMgr } from 'src/app/model/SubscriptionMgr';
import { DictHandler } from 'src/app/types/@types/sl-v-types';
import { SLMap } from 'src/app/model/sl-map';
import { LayerViewsService, ILayerViewLayer } from 'src/app/model/api-services/layer-views.service';
import { ISLMap } from 'src/app/types/@types/sl-map';
import { LayerListProviderService, ILayerViewLayerNode } from 'src/app/services/layer-list-provider.service';
import { TREE_ACTIONS, TreeModel, TreeNode, TreeComponent } from '@circlon/angular-tree-component';
import { ModalLayerSelectionComponent } from './modal-layer-selection/modal-layer-selection.component';
import { LayerSelectionDialogService } from './layer-selection-dialog.service.';
import { ViewStackComponent } from '../../view-stack/view-stack.component';
import { ViewRequest, LayerGalleryComponent } from './layer-gallery/layer-gallery.component';
import { IconButtonComponent } from '../../icon-button/icon-button.component';
import { ResultMoment, ResultsService } from 'src/app/services/results.service';
export interface ILayerSelectDialogConfig {
	handler: DictHandler;
	layers?: Array<ILayerViewLayer>;
	map?: ISLMap;
	mode: 'from-map' | 'from-views' | 'from-set' | 'gallery';
	selectDefault: boolean;
	selections: any;
	moment?: ResultMoment;
}

@Component({
	selector: 'app-layer-selection-dialog',
	templateUrl: './layer-selection-dialog.component.html',
	styleUrls: ['./layer-selection-dialog.component.scss'],
	// tslint:disable-next-line: no-host-metadata-property
	host: {
		class: 'layer-selection-dialog work-view'
	}

})
export class LayerSelectionDialogComponent implements OnInit, AfterContentInit, OnDestroy {

	@ViewChild('buttonOne', { static: true }) buttonOne: ElementRef;
	@ViewChild('buttonTwo', { static: true }) buttonTwo: ElementRef;
	@ViewChild('closeButton', { static: true }) closeButton: ElementRef;

	@ViewChild('views', { static: true }) views !: ViewStackComponent;
	@ViewChild('layerGallery', { static: true }) layerGallery !: LayerGalleryComponent;

	@ViewChild('layersDisplay', { static: true }) layersDisplay: ModalLayerSelectionComponent;
	public actions: EventEmitter<any> = new EventEmitter();

	public viewsReady = false;


	public treeOptions = {
		allowDrag: false
	};
	public layers: Array<any> = [
		{
			name: 'layers',
			children: []
		}
	];

	private map: ISLMap = null;
	private layerSet: Array<ILayerViewLayer>;
	private handler: DictHandler;
	private selections: any;
	constructor(
		private activeModal: NgbActiveModal,
		private layerViews: LayerViewsService,
		private layerLists: LayerListProviderService,
		private layerSelDialogSvc: LayerSelectionDialogService,
		private resultsSvc: ResultsService
	) { }
	private subscriptionMgr: SubScriptionMgr = new SubScriptionMgr();

	ngOnInit() {

	}
	ngAfterContentInit() {
		/* this.subscriptionMgr.Subscribe(this.tabs.tabChange, (data: NgbTabChangeEvent) => {

		});
		*/
		this.subscriptionMgr.Subscribe(this.layerGallery.viewRequests, (request: ViewRequest) => {
			this.RequestView(request);
		})
    /*
		this.closeButton.nativeElement.addEventListener('click', (event) => {
			this.activeModal.close();
		});
    */

		/*
		this.buttonOne.nativeElement.addEventListener('click', () => {
			this.HandleButtonOne();
		});
		this.buttonTwo.nativeElement.addEventListener('click', () => {
			this.activeModal.close();
		});
		*/
	}
	HandleNodeExpander(node: any, event: any) {

	}
	IsHeading(node, index) {
		return node.data === this.layers[0];
	}
	Show(info: ILayerSelectDialogConfig) {
		this.handler = info.handler;
		this.layersDisplay.Show(info);
	}
	ShowGallery() {
		const moment: ResultMoment = this.layersDisplay.MergeMoment();
		this.resultsSvc.history.UpdateMoment(moment);
		this.views.SetView('gallery');
	}
	public RequestView(request: ViewRequest): void {
		switch (request.name) {
			case 'layers':
				this.layersDisplay.Show({
					handler: this.handler,
					mode: 'gallery',
					selectDefault: false,
					selections: {},
					layers: request.data,
					moment: request.moment
				})
				this.views.SetView('layers');
				break;
			case 'gallery':

				break;
		}
	}
	HandleButtonOne() {
		this.handler({ selections: this.layersDisplay.currentSelections });
		this.activeModal.close();
	}

	NotifyListeners() {
		const layers: Array<ILayerViewLayerNode> = this.layers[0].children;
		for (const item of layers) {
			this.selections[item.layer.id] = item.isSelected;
		}
		this.handler({ selections: this.selections });

	}
  Close() {
    this.activeModal.close();
  }
	ngOnDestroy() {
		this.subscriptionMgr.CancelSubscriptions();
	}
}

@Component({
	selector: 'app-layer-selection-dialog-entry',
	template: ''
})
export class LayerSelectionDialogEntryComponent implements OnDestroy {
	modalRef: NgbModalRef;
	subscriptionMgr: SubScriptionMgr = new SubScriptionMgr();
	lastTitle: string | null = null;

	constructor(private modalService: NgbModal, private service: LayerSelectionDialogService) {

		this.subscriptionMgr.Subscribe(this.service.request$, (info: any) => {
			this.modalRef = this.modalService.open(LayerSelectionDialogComponent, { backdrop: 'static' });
			(this.modalRef.componentInstance as LayerSelectionDialogComponent).Show(info);
		});


	}
	ngOnDestroy() {
		this.subscriptionMgr.CancelSubscriptions();
	}
}

